import { render, staticRenderFns } from "./call-the-police.vue?vue&type=template&id=560d2778&scoped=true"
import script from "./call-the-police.vue?vue&type=script&lang=js"
export * from "./call-the-police.vue?vue&type=script&lang=js"
import style0 from "./call-the-police.vue?vue&type=style&index=0&id=560d2778&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560d2778",
  null
  
)

export default component.exports